/* @generated */
// prettier-ignore
if (Intl.DisplayNames && typeof Intl.DisplayNames.__addLocaleData === 'function') {
  Intl.DisplayNames.__addLocaleData({
  "data": {
    "patterns": {
      "locale": "{0} ({1})"
    },
    "types": {
      "calendar": {
        "long": {
          "buddhist": "будистички календар",
          "chinese": "кинески календар",
          "coptic": "коптски календар",
          "dangi": "данги календар",
          "ethiopic": "етиопски календар",
          "ethiopic-amete-alem": "етиопски амет алем календар",
          "gregorian": "грегоријански календар",
          "hebrew": "хебрејски календар",
          "indian": "Индијски национални календар",
          "islamic": "исламски календар",
          "islamic-civil": "Исламски цивилни календар",
          "islamic-rgsa": "islamic-rgsa",
          "islamic-tbla": "islamic-tbla",
          "islamic-umalqura": "исламски календар (Umm al-Qura)",
          "iso8601": "ISO-8601 календар",
          "japanese": "јапански календар",
          "persian": "персијски календар",
          "roc": "календар Републике Кине"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "currency": {
        "long": {
          "ADP": "Андорска пезета",
          "AED": "дирхам УАЕ",
          "AFA": "Авганистански авгани (1927–2002)",
          "AFN": "авганистански авгани",
          "ALK": "ALK",
          "ALL": "албански лек",
          "AMD": "јерменски драм",
          "ANG": "холандскоантилски гулден",
          "AOA": "анголска кванза",
          "AOK": "Анголијска кванза (1977–1990)",
          "AON": "Анголијска нова кванза (1990–2000)",
          "AOR": "Анголијска кванза реађустадо (1995–1999)",
          "ARA": "Аргентински аустрал",
          "ARL": "ARL",
          "ARM": "ARM",
          "ARP": "Аргентински пезо (1983–1985)",
          "ARS": "аргентински пезос",
          "ATS": "Аустријски шилинг",
          "AUD": "аустралијски долар",
          "AWG": "арубански флорин",
          "AZM": "Азербејџански манат (1993–2006)",
          "AZN": "азербејџански манат",
          "BAD": "Босанско-Херцеговачки динар",
          "BAM": "босанско-херцеговачка конвертибилна марка",
          "BAN": "BAN",
          "BBD": "барбадошки долар",
          "BDT": "бангладешка така",
          "BEC": "Белгијски франак (конвертибилни)",
          "BEF": "Белгијски франак",
          "BEL": "Белгијски франак (финансијски)",
          "BGL": "Бугарски тврди лев",
          "BGM": "BGM",
          "BGN": "бугарски лев",
          "BGO": "BGO",
          "BHD": "бахреински динар",
          "BIF": "бурундски франак",
          "BMD": "бермудски долар",
          "BND": "брунејски долар",
          "BOB": "боливијски боливијано",
          "BOL": "BOL",
          "BOP": "Боливијски пезо",
          "BOV": "Боливијски мвдол",
          "BRB": "Бразилски нови крузеиро (1967–1986)",
          "BRC": "Бразилијски крузадо",
          "BRE": "Бразилски крузеиро (1990–1993)",
          "BRL": "бразилски реал",
          "BRN": "Бразилијски нови крузадо",
          "BRR": "Бразилски крузеиро",
          "BRZ": "BRZ",
          "BSD": "бахамски долар",
          "BTN": "бутански нгултрум",
          "BUK": "Бурмански кјат",
          "BWP": "боцванска пула",
          "BYB": "Белоруска нова рубља (1994–1999)",
          "BYN": "белоруска рубља",
          "BYR": "Белоруска рубља (2000–2016)",
          "BZD": "белиски долар",
          "CAD": "канадски долар",
          "CDF": "конгоански франак",
          "CHE": "WIR евро",
          "CHF": "швајцарски франак",
          "CHW": "WIR франак",
          "CLE": "CLE",
          "CLF": "Чилеовски унидадес се фоменто",
          "CLP": "чилеански пезос",
          "CNH": "кинески јуан (острвски)",
          "CNX": "CNX",
          "CNY": "кинески јуан",
          "COP": "колумбијски пезос",
          "COU": "Унидад де валоршки реал",
          "CRC": "костарикански колон",
          "CSD": "Стари српски динар",
          "CSK": "Чехословачка тврда круна",
          "CUC": "кубански конвертибилни пезос",
          "CUP": "кубански пезос",
          "CVE": "зеленортски ескудо",
          "CYP": "Кипарска фунта",
          "CZK": "чешка круна",
          "DDM": "Источно-немачка марка",
          "DEM": "Немачка марка",
          "DJF": "џибутски франак",
          "DKK": "данска круна",
          "DOP": "доминикански пезос",
          "DZD": "алжирски динар",
          "ECS": "Еквадорски сакр",
          "ECV": "Еквадорски унидад де валор константе",
          "EEK": "Естонска кроон",
          "EGP": "египатска фунта",
          "ERN": "еритрејска накфа",
          "ESA": "Шпанска пезета (рачун)",
          "ESB": "Шпанска пезета (конвертибилнирачун)",
          "ESP": "Шпанска пезета",
          "ETB": "етиопијски бир",
          "EUR": "Евро",
          "FIM": "Финска марка",
          "FJD": "фиџијски долар",
          "FKP": "фолкландска фунта",
          "FRF": "Француски франак",
          "GBP": "британска фунта",
          "GEK": "Грузијски купон ларит",
          "GEL": "грузијски лари",
          "GHC": "Гански цеди (1979–2007)",
          "GHS": "гански седи",
          "GIP": "гибралтарска фунта",
          "GMD": "гамбијски даласи",
          "GNF": "гвинејски франак",
          "GNS": "Гвинејски сили",
          "GQE": "Екваторијално-гвинејски еквеле",
          "GRD": "Грчка драхма",
          "GTQ": "гватемалски кецал",
          "GWE": "Португалска гвинеја ескудо",
          "GWP": "Гвинеја Бисао Пезо",
          "GYD": "гвајански долар",
          "HKD": "хонгконшки долар",
          "HNL": "хондурашка лемпира",
          "HRD": "Хрватски динар",
          "HRK": "хрватска куна",
          "HTG": "хаићански гурд",
          "HUF": "мађарска форинта",
          "IDR": "индонежанска рупија",
          "IEP": "Ирска фунта",
          "ILP": "Израелска фунта",
          "ILR": "Стари израелски шекели",
          "ILS": "израелски нови шекел",
          "INR": "индијска рупија",
          "IQD": "ирачки динар",
          "IRR": "ирански ријал",
          "ISJ": "Стара исландска круна",
          "ISK": "исландска круна",
          "ITL": "Италијанска лира",
          "JMD": "јамајчански долар",
          "JOD": "јордански динар",
          "JPY": "јапански јен",
          "KES": "кенијски шилинг",
          "KGS": "киргистански сом",
          "KHR": "камбоџански ријел",
          "KMF": "коморски франак",
          "KPW": "севернокорејски вон",
          "KRH": "KRH",
          "KRO": "KRO",
          "KRW": "јужнокорејски вон",
          "KWD": "кувајтски динар",
          "KYD": "кајмански долар",
          "KZT": "казахстански тенге",
          "LAK": "лаоски кип",
          "LBP": "либанска фунта",
          "LKR": "шриланчанска рупија",
          "LRD": "либеријски долар",
          "LSL": "лесотски лоти",
          "LTL": "Литвански литас",
          "LTT": "Литвански талонас",
          "LUC": "Луксембуршки конвертибилни франак",
          "LUF": "Луксембуршки франак",
          "LUL": "Луксембуршки финансијски франак",
          "LVL": "Латвијски лати",
          "LVR": "Латвијска рубља",
          "LYD": "либијски динар",
          "MAD": "марокански дирхам",
          "MAF": "Марокански франак",
          "MCF": "MCF",
          "MDC": "MDC",
          "MDL": "молдавски леј",
          "MGA": "малгашки аријари",
          "MGF": "Малагасијски франак",
          "MKD": "македонски денар",
          "MKN": "MKN",
          "MLF": "Малијански франак",
          "MMK": "мјанмарски кјат",
          "MNT": "монголски тугрик",
          "MOP": "макаоска патака",
          "MRO": "Мауританијска oгија (1973–2017)",
          "MRU": "мауританска огија",
          "MTL": "Малтешка лира",
          "MTP": "Малтешка фунта",
          "MUR": "маурицијска рупија",
          "MVP": "MVP",
          "MVR": "малдивска руфија",
          "MWK": "малавијска квача",
          "MXN": "мексички пезос",
          "MXP": "Мексички сребрни пезо (1861–1992)",
          "MXV": "Мексички унидад де инверсион (UDI)",
          "MYR": "малезијски рингит",
          "MZE": "Мозамбијски ескудо",
          "MZM": "Стари мозамбијски метикал",
          "MZN": "мозамбички метикал",
          "NAD": "намибијски долар",
          "NGN": "нигеријска наира",
          "NIC": "никарагванска кордоба (1988–1991)",
          "NIO": "никарагванска кордоба",
          "NLG": "Холандски гулден",
          "NOK": "норвешка круна",
          "NPR": "непалска рупија",
          "NZD": "новозеландски долар",
          "OMR": "омански ријал",
          "PAB": "панамска балбоа",
          "PEI": "Перуански инти",
          "PEN": "перуански сол",
          "PES": "Перуански сол (1863–1965)",
          "PGK": "папуанска кина",
          "PHP": "филипински пезос",
          "PKR": "пакистанска рупија",
          "PLN": "пољски злот",
          "PLZ": "Пољски злоти (1950–1995)",
          "PTE": "Португалски ескудо",
          "PYG": "парагвајски гварани",
          "QAR": "катарски ријал",
          "RHD": "Родејскидолар",
          "ROL": "Румунски леј (1952–2006)",
          "RON": "румунски леј",
          "RSD": "српски динар",
          "RUB": "руска рубља",
          "RUR": "Руска рубља (1991–1998)",
          "RWF": "руандски франак",
          "SAR": "саудијски ријал",
          "SBD": "соломонски долар",
          "SCR": "сејшелска рупија",
          "SDD": "Стари судански динар",
          "SDG": "суданска фунта",
          "SDP": "Стара суданска фунта",
          "SEK": "шведска круна",
          "SGD": "сингапурски долар",
          "SHP": "фунта Свете Јелене",
          "SIT": "Словеначки толар",
          "SKK": "Словачка круна",
          "SLL": "сијералеонски леоне",
          "SOS": "сомалијски шилинг",
          "SRD": "суринамски долар",
          "SRG": "Суринамски гилдер",
          "SSP": "јужносуданска фунта",
          "STD": "Саотомска добра (1977–2017)",
          "STN": "саотомска добра",
          "SUR": "Совјетска рубља",
          "SVC": "Салвадорски колон",
          "SYP": "сиријска фунта",
          "SZL": "свазилендски лилангени",
          "THB": "тајландски бат",
          "TJR": "Таџихистанска рубља",
          "TJS": "таџикистански сомон",
          "TMM": "Туркменистански манат (1993–2009)",
          "TMT": "туркменистански манат",
          "TND": "туниски динар",
          "TOP": "тонганска панга",
          "TPE": "Тиморшки ескудо",
          "TRL": "Турска лира (1922–2005)",
          "TRY": "турска лира",
          "TTD": "Тринидад-тобагошки долар",
          "TWD": "нови тајвански долар",
          "TZS": "танзанијски шилинг",
          "UAH": "украјинска гривна",
          "UAK": "Украјински карбованети",
          "UGS": "Угандски шилинг (1966–1987)",
          "UGX": "угандски шилинг",
          "USD": "амерички долар",
          "USN": "САД долар (следећи дан)",
          "USS": "САД долар (исти дан)",
          "UYI": "Уругвајски пезо ен унидадес индексадас",
          "UYP": "Уругвајски пезо (1975–1993)",
          "UYU": "уругвајски пезос",
          "UYW": "UYW",
          "UZS": "узбекистански сом",
          "VEB": "Венецуелански боливар (1871–2008)",
          "VEF": "Венецуелански боливар (2008–2018)",
          "VES": "венецуелански боливар",
          "VND": "вијетнамски донг",
          "VNN": "Вијетнамски донг (1978–1985)",
          "VUV": "вануатски вату",
          "WST": "самоанска тала",
          "XAF": "централноафрички франак",
          "XAG": "Сребро",
          "XAU": "Злато",
          "XBA": "Европска композитна јединица",
          "XBB": "Европска новчана јединица",
          "XBC": "Европска јединица рачуна (XBC)",
          "XBD": "Европска јединица рачуна (XBD)",
          "XCD": "источнокарипски долар",
          "XDR": "Посебна цртаћа права",
          "XEU": "Европска валутна јединица",
          "XFO": "Француски златни франак",
          "XFU": "Француски UIC-франак",
          "XOF": "западноафрички франак",
          "XPD": "Паладијум",
          "XPF": "CFP франак",
          "XPT": "Платина",
          "XRE": "RINET фонд",
          "XSU": "XSU",
          "XTS": "Код тестиране валуте",
          "XUA": "XUA",
          "XXX": "Непозната валута",
          "YDD": "Јеменски динар",
          "YER": "јеменски ријал",
          "YUD": "Југословенски тврди динар",
          "YUM": "Југословенски нови динар",
          "YUN": "Југословенски конвертибилни динар",
          "YUR": "YUR",
          "ZAL": "Јужно-афрички ранд (финансијски)",
          "ZAR": "јужноафрички ранд",
          "ZMK": "Замбијска квача (1968–2012)",
          "ZMW": "замбијска квача",
          "ZRN": "Заирски нови заир",
          "ZRZ": "Заирски заир",
          "ZWD": "Зимбабвеански долар (1980–2008)",
          "ZWL": "Зимбабвеански долар (2009)",
          "ZWR": "Зимбабвеански долар (2008)"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "dateTimeField": {
        "long": {
          "day": "дан",
          "dayOfYear": "дан у години",
          "dayperiod": "AM/PM",
          "era": "ера",
          "hour": "сат",
          "minute": "минут",
          "month": "месец",
          "quarter": "квартал",
          "second": "секунд",
          "timeZoneName": "временска зона",
          "weekOfMonth": "недеља у месецу",
          "weekOfYear": "недеља",
          "weekday": "дан у недељи",
          "weekdayOfMonth": "дан у месецу",
          "year": "година"
        },
        "narrow": {
          "day": "д.",
          "dayOfYear": "дан у год.",
          "dayperiod": "пре подне/по подне",
          "era": "ера",
          "hour": "ч.",
          "minute": "мин.",
          "month": "мес.",
          "quarter": "кв.",
          "second": "с",
          "timeZoneName": "временска зона",
          "weekOfMonth": "нед. у мес.",
          "weekOfYear": "нед.",
          "weekday": "дан у недељи",
          "weekdayOfMonth": "дан у месецу",
          "year": "г."
        },
        "short": {
          "day": "д.",
          "dayOfYear": "дан у год.",
          "dayperiod": "пре подне/по подне",
          "era": "ера",
          "hour": "ч.",
          "minute": "мин.",
          "month": "мес.",
          "quarter": "кв.",
          "second": "сек.",
          "timeZoneName": "временска зона",
          "weekOfMonth": "нед. у мес.",
          "weekOfYear": "нед.",
          "weekday": "дан у недељи",
          "weekdayOfMonth": "дан у месецу",
          "year": "год."
        }
      },
      "language": {
        "dialect": {
          "long": {
            "aa": "афарски",
            "ab": "абхаски",
            "ace": "ацешки",
            "ach": "аколи",
            "ada": "адангме",
            "ady": "адигејски",
            "ae": "авестански",
            "af": "африканс",
            "afh": "африхили",
            "agq": "агем",
            "ain": "аину",
            "ak": "акански",
            "akk": "акадијски",
            "ale": "алеутски",
            "alt": "јужноалтајски",
            "am": "амхарски",
            "an": "арагонски",
            "ang": "староенглески",
            "anp": "ангика",
            "ar": "арапски",
            "ar-001": "савремени стандардни арапски",
            "arc": "арамејски",
            "arn": "мапудунгун",
            "arp": "арапахо",
            "arw": "аравачки",
            "as": "асамски",
            "asa": "асу",
            "ast": "астуријски",
            "av": "аварски",
            "awa": "авади",
            "ay": "ајмара",
            "az": "азербејџански",
            "ba": "башкирски",
            "bal": "белучки",
            "ban": "балијски",
            "bas": "баса",
            "be": "бјелоруски",
            "bej": "беџа",
            "bem": "бемба",
            "bez": "бена",
            "bg": "бугарски",
            "bgn": "западни белучки",
            "bho": "боџпури",
            "bi": "бислама",
            "bik": "бикол",
            "bin": "бини",
            "bla": "сисика",
            "bm": "бамананкан",
            "bn": "бангла",
            "bo": "тибетански",
            "br": "бретонски",
            "bra": "брај",
            "brx": "бодо",
            "bs": "босански",
            "bua": "бурјатски",
            "bug": "бугијски",
            "byn": "блински",
            "ca": "каталонски",
            "cad": "кадо",
            "car": "карипски",
            "cch": "атсам",
            "ccp": "чакма",
            "ce": "чеченски",
            "ceb": "себуански",
            "cgg": "чига",
            "ch": "чаморо",
            "chb": "чипча",
            "chg": "чагатај",
            "chk": "чучки",
            "chm": "мари",
            "chn": "чинучки",
            "cho": "чоктавски",
            "chp": "чипевјански",
            "chr": "чероки",
            "chy": "чејенски",
            "ckb": "централни курдски",
            "co": "корзикански",
            "cop": "коптски",
            "cr": "кри",
            "crh": "кримскотатарски",
            "crs": "сејшелски креолски француски",
            "cs": "чешки",
            "csb": "кашупски",
            "cu": "црквенословенски",
            "cv": "чувашки",
            "cy": "велшки",
            "da": "дански",
            "dak": "дакота",
            "dar": "даргински",
            "dav": "таита",
            "de": "немачки",
            "de-AT": "аустријски немачки",
            "de-CH": "швајцарски високи немачки",
            "del": "делаверски",
            "den": "слејви",
            "dgr": "догрипски",
            "din": "динка",
            "dje": "зарма",
            "doi": "догри",
            "dsb": "доњолужичкосрпски",
            "dua": "дуала",
            "dum": "средњехоландски",
            "dv": "малдивски",
            "dyo": "џола фоњи",
            "dyu": "ђула",
            "dz": "џонга",
            "dzg": "дазага",
            "ebu": "ембу",
            "ee": "еве",
            "efi": "ефички",
            "egy": "староегипатски",
            "eka": "екаџук",
            "el": "грчки",
            "elx": "еламитски",
            "en": "енглески",
            "en-AU": "енглески (Аустралија)",
            "en-CA": "енглески (Канада)",
            "en-GB": "енглески (Велика Британија)",
            "en-US": "енглески (Сједињене Америчке Државе)",
            "enm": "средњеенглески",
            "eo": "есперанто",
            "es": "шпански",
            "es-419": "шпански (Латинска Америка)",
            "es-ES": "шпански (Европа)",
            "es-MX": "шпански (Мексико)",
            "et": "естонски",
            "eu": "баскијски",
            "ewo": "евондо",
            "fa": "персијски",
            "fa-AF": "дари",
            "fan": "фанг",
            "fat": "фанти",
            "ff": "фулах",
            "fi": "фински",
            "fil": "филипински",
            "fj": "фиџијски",
            "fo": "фарски",
            "fon": "фон",
            "fr": "француски",
            "fr-CA": "француски (Канада)",
            "fr-CH": "француски (Швајцарска)",
            "frc": "кајунски француски",
            "frm": "средњефранцуски",
            "fro": "старофранцуски",
            "frr": "севернофризијски",
            "frs": "источнофризијски",
            "fur": "фриулски",
            "fy": "западни фризијски",
            "ga": "ирски",
            "gaa": "га",
            "gag": "гагауз",
            "gay": "гајо",
            "gba": "гбаја",
            "gd": "шкотски гелски",
            "gez": "геез",
            "gil": "гилбертски",
            "gl": "галицијски",
            "gmh": "средњи високонемачки",
            "gn": "гварани",
            "goh": "старонемачки",
            "gon": "гонди",
            "gor": "горонтало",
            "got": "готски",
            "grb": "гребо",
            "grc": "старогрчки",
            "gsw": "немачки (Швајцарска)",
            "gu": "гуџарати",
            "guz": "гуси",
            "gv": "манкс",
            "gwi": "гвичински",
            "ha": "хауса",
            "hai": "хаида",
            "haw": "хавајски",
            "he": "хебрејски",
            "hi": "хинди",
            "hil": "хилигајнонски",
            "hit": "хетитски",
            "hmn": "хмоншки",
            "ho": "хири моту",
            "hr": "хрватски",
            "hsb": "горњолужичкосрпски",
            "ht": "хаићански креолски",
            "hu": "мађарски",
            "hup": "хупа",
            "hy": "јерменски",
            "hz": "хереро",
            "ia": "интерлингва",
            "iba": "ибански",
            "ibb": "ибибио",
            "id": "индонежански",
            "ie": "интерлингве",
            "ig": "игбо",
            "ii": "сечуански ји",
            "ik": "инупик",
            "ilo": "илоко",
            "inh": "ингушки",
            "io": "идо",
            "is": "исландски",
            "it": "италијански",
            "iu": "инуктитутски",
            "ja": "јапански",
            "jbo": "ложбан",
            "jgo": "нгомба",
            "jmc": "мачаме",
            "jpr": "јудео-персијски",
            "jrb": "јудео-арапски",
            "jv": "јавански",
            "ka": "грузијски",
            "kaa": "кара-калпашки",
            "kab": "кабиле",
            "kac": "качински",
            "kaj": "џу",
            "kam": "камба",
            "kaw": "кави",
            "kbd": "кабардијски",
            "kcg": "тјап",
            "kde": "маконде",
            "kea": "зеленортски",
            "kfo": "коро",
            "kg": "конго",
            "kgp": "kgp",
            "kha": "каси",
            "kho": "котанешки",
            "khq": "којра чиини",
            "ki": "кикују",
            "kj": "квањама",
            "kk": "казашки",
            "kkj": "како",
            "kl": "гренландски",
            "kln": "каленџински",
            "km": "кмерски",
            "kmb": "кимбунду",
            "kn": "канада",
            "ko": "корејски",
            "koi": "коми-пермски",
            "kok": "конкани",
            "kos": "косренски",
            "kpe": "кпеле",
            "kr": "канури",
            "krc": "карачајско-балкарски",
            "kri": "крио",
            "krl": "карелски",
            "kru": "курук",
            "ks": "кашмирски",
            "ksb": "шамбала",
            "ksf": "бафија",
            "ksh": "келнски",
            "ku": "курдски",
            "kum": "кумички",
            "kut": "кутенај",
            "kv": "коми",
            "kw": "корнволски",
            "ky": "киргиски",
            "la": "латински",
            "lad": "ладино",
            "lag": "ланги",
            "lah": "ланда",
            "lam": "ламба",
            "lb": "луксембуршки",
            "lez": "лезгински",
            "lg": "ганда",
            "li": "лимбуршки",
            "lij": "lij",
            "lkt": "лакота",
            "ln": "лингала",
            "lo": "лаошки",
            "lol": "монго",
            "lou": "луизијански креолски",
            "loz": "лози",
            "lrc": "северни лури",
            "lt": "литвански",
            "lu": "луба-катанга",
            "lua": "луба-лулуа",
            "lui": "луисењо",
            "lun": "лунда",
            "luo": "луо",
            "lus": "мизо",
            "luy": "лујиа",
            "lv": "летонски",
            "mad": "мадурски",
            "mag": "магахи",
            "mai": "маитили",
            "mak": "макасарски",
            "man": "мандинго",
            "mas": "масајски",
            "mdf": "мокша",
            "mdr": "мандар",
            "men": "менде",
            "mer": "меру",
            "mfe": "морисјен",
            "mg": "малгашки",
            "mga": "средњеирски",
            "mgh": "макува-мито",
            "mgo": "мета",
            "mh": "маршалски",
            "mi": "маорски",
            "mic": "микмак",
            "min": "минангкабау",
            "mk": "македонски",
            "ml": "малајалам",
            "mn": "монголски",
            "mnc": "манџурски",
            "mni": "манипурски",
            "moh": "мохок",
            "mos": "моси",
            "mr": "марати",
            "ms": "малајски",
            "mt": "малтешки",
            "mua": "мунданг",
            "mul": "Више језика",
            "mus": "кришки",
            "mwl": "мирандски",
            "mwr": "марвари",
            "my": "бурмански",
            "myv": "ерзја",
            "mzn": "мазандерански",
            "na": "науруски",
            "nap": "напуљски",
            "naq": "нама",
            "nb": "норвешки букмол",
            "nd": "северни ндебеле",
            "nds": "нисконемачки",
            "nds-NL": "нискосаксонски",
            "ne": "непалски",
            "new": "невари",
            "ng": "ндонга",
            "nia": "ниас",
            "niu": "ниуејски",
            "nl": "холандски",
            "nl-BE": "фламански",
            "nmg": "квасио",
            "nn": "норвешки нинорск",
            "nnh": "нгиембун",
            "no": "норвешки",
            "nog": "ногајски",
            "non": "старонордијски",
            "nqo": "н’ко",
            "nr": "јужни ндебеле",
            "nso": "северни сото",
            "nus": "нуер",
            "nv": "навахо",
            "nwc": "класични неварски",
            "ny": "њанџа",
            "nym": "њамвези",
            "nyn": "њанколе",
            "nyo": "њоро",
            "nzi": "нзима",
            "oc": "окситански",
            "oj": "оџибве",
            "om": "оромо",
            "or": "одија",
            "os": "осетински",
            "osa": "осаге",
            "ota": "османски турски",
            "pa": "пенџапски",
            "pag": "пангасинански",
            "pal": "пахлави",
            "pam": "пампанга",
            "pap": "папијаменто",
            "pau": "палауски",
            "pcm": "нигеријски пиџин",
            "peo": "староперсијски",
            "phn": "феничански",
            "pi": "пали",
            "pl": "пољски",
            "pon": "понпејски",
            "prg": "пруски",
            "pro": "староокситански",
            "ps": "паштунски",
            "pt": "португалски",
            "pt-BR": "португалски (Бразил)",
            "pt-PT": "португалски (Португал)",
            "qu": "кечуа",
            "quc": "киче",
            "raj": "раџастански",
            "rap": "рапануи",
            "rar": "раротонгански",
            "rhg": "рохингја",
            "rm": "романш",
            "rn": "кирунди",
            "ro": "румунски",
            "ro-MD": "молдавски",
            "rof": "ромбо",
            "rom": "ромски",
            "ru": "руски",
            "rup": "цинцарски",
            "rw": "кињаруанда",
            "rwk": "руа",
            "sa": "санскрит",
            "sad": "сандаве",
            "sah": "саха",
            "sam": "самаријански арамејски",
            "saq": "самбуру",
            "sas": "сасак",
            "sat": "сантали",
            "sba": "нгамбај",
            "sbp": "сангу",
            "sc": "сардински",
            "scn": "сицилијански",
            "sco": "шкотски",
            "sd": "синди",
            "sdh": "јужнокурдски",
            "se": "северни сами",
            "seh": "сена",
            "sel": "селкупски",
            "ses": "којраборо сени",
            "sg": "санго",
            "sga": "староирски",
            "sh": "српскохрватски",
            "shi": "јужни шилха",
            "shn": "шански",
            "si": "синхалешки",
            "sid": "сидамо",
            "sk": "словачки",
            "sl": "словеначки",
            "sm": "самоански",
            "sma": "јужни сами",
            "smj": "луле сами",
            "smn": "инари сами",
            "sms": "сколт сами",
            "sn": "шона",
            "snk": "сонинке",
            "so": "сомалски",
            "sog": "согдијски",
            "sq": "албански",
            "sr": "српски",
            "srn": "сранан тонго",
            "srr": "серерски",
            "ss": "свази",
            "ssy": "сахо",
            "st": "сесото",
            "su": "сундански",
            "suk": "сукума",
            "sus": "сусу",
            "sux": "сумерски",
            "sv": "шведски",
            "sw": "свахили",
            "sw-CD": "кисвахили",
            "swb": "коморски",
            "syc": "сиријачки",
            "syr": "сиријски",
            "ta": "тамилски",
            "te": "телугу",
            "tem": "тимне",
            "teo": "тесо",
            "ter": "терено",
            "tet": "тетум",
            "tg": "таџички",
            "th": "тајски",
            "ti": "тигриња",
            "tig": "тигре",
            "tiv": "тив",
            "tk": "туркменски",
            "tkl": "токелау",
            "tl": "тагалог",
            "tlh": "клингонски",
            "tli": "тлингит",
            "tmh": "тамашек",
            "tn": "цвана",
            "to": "тонгански",
            "tog": "њаса тонга",
            "tpi": "ток писин",
            "tr": "турски",
            "trv": "тароко",
            "ts": "цонга",
            "tsi": "цимшиан",
            "tt": "татарски",
            "tum": "тумбука",
            "tvl": "тувалу",
            "tw": "тви",
            "twq": "тасавак",
            "ty": "тахићански",
            "tyv": "тувински",
            "tzm": "централноатласки тамашек",
            "udm": "удмуртски",
            "ug": "ујгурски",
            "uga": "угаритски",
            "uk": "украјински",
            "umb": "умбунду",
            "und": "непознат језик",
            "ur": "урду",
            "uz": "узбечки",
            "vai": "ваи",
            "ve": "венда",
            "vi": "вијетнамски",
            "vo": "волапик",
            "vot": "водски",
            "vun": "вунџо",
            "wa": "валонски",
            "wae": "валсерски",
            "wal": "волајта",
            "war": "варајски",
            "was": "вашо",
            "wbp": "варлпири",
            "wo": "волоф",
            "xal": "калмички",
            "xh": "исикоса",
            "xog": "сога",
            "yao": "јао",
            "yap": "јапски",
            "yav": "јангбен",
            "ybb": "јемба",
            "yi": "јидиш",
            "yo": "јоруба",
            "yrl": "yrl",
            "yue": "кантонски",
            "za": "џуаншки",
            "zap": "запотечки",
            "zbl": "блисимболи",
            "zen": "зенага",
            "zgh": "стандардни марокански тамашек",
            "zh": "кинески",
            "zh-Hans": "поједностављени кинески",
            "zh-Hant": "традиционални кинески",
            "zu": "исизулу",
            "zun": "зуни",
            "zxx": "без лингвистичког садржаја",
            "zza": "заза"
          },
          "narrow": {
          },
          "short": {
            "az": "азерски",
            "en-GB": "енглески (Велика Британија)",
            "en-US": "енглески (Сједињене Америчке Државе)"
          }
        },
        "standard": {
          "long": {
            "aa": "афарски",
            "ab": "абхаски",
            "ace": "ацешки",
            "ach": "аколи",
            "ada": "адангме",
            "ady": "адигејски",
            "ae": "авестански",
            "af": "африканс",
            "afh": "африхили",
            "agq": "агем",
            "ain": "аину",
            "ak": "акански",
            "akk": "акадијски",
            "ale": "алеутски",
            "alt": "јужноалтајски",
            "am": "амхарски",
            "an": "арагонски",
            "ang": "староенглески",
            "anp": "ангика",
            "ar": "арапски",
            "ar-001": "арапски (свет)",
            "arc": "арамејски",
            "arn": "мапудунгун",
            "arp": "арапахо",
            "arw": "аравачки",
            "as": "асамски",
            "asa": "асу",
            "ast": "астуријски",
            "av": "аварски",
            "awa": "авади",
            "ay": "ајмара",
            "az": "азербејџански",
            "ba": "башкирски",
            "bal": "белучки",
            "ban": "балијски",
            "bas": "баса",
            "be": "бјелоруски",
            "bej": "беџа",
            "bem": "бемба",
            "bez": "бена",
            "bg": "бугарски",
            "bgn": "западни белучки",
            "bho": "боџпури",
            "bi": "бислама",
            "bik": "бикол",
            "bin": "бини",
            "bla": "сисика",
            "bm": "бамананкан",
            "bn": "бангла",
            "bo": "тибетански",
            "br": "бретонски",
            "bra": "брај",
            "brx": "бодо",
            "bs": "босански",
            "bua": "бурјатски",
            "bug": "бугијски",
            "byn": "блински",
            "ca": "каталонски",
            "cad": "кадо",
            "car": "карипски",
            "cch": "атсам",
            "ccp": "чакма",
            "ce": "чеченски",
            "ceb": "себуански",
            "cgg": "чига",
            "ch": "чаморо",
            "chb": "чипча",
            "chg": "чагатај",
            "chk": "чучки",
            "chm": "мари",
            "chn": "чинучки",
            "cho": "чоктавски",
            "chp": "чипевјански",
            "chr": "чероки",
            "chy": "чејенски",
            "ckb": "централни курдски",
            "co": "корзикански",
            "cop": "коптски",
            "cr": "кри",
            "crh": "кримскотатарски",
            "crs": "сејшелски креолски француски",
            "cs": "чешки",
            "csb": "кашупски",
            "cu": "црквенословенски",
            "cv": "чувашки",
            "cy": "велшки",
            "da": "дански",
            "dak": "дакота",
            "dar": "даргински",
            "dav": "таита",
            "de": "немачки",
            "de-AT": "немачки (Аустрија)",
            "de-CH": "немачки (Швајцарска)",
            "del": "делаверски",
            "den": "слејви",
            "dgr": "догрипски",
            "din": "динка",
            "dje": "зарма",
            "doi": "догри",
            "dsb": "доњолужичкосрпски",
            "dua": "дуала",
            "dum": "средњехоландски",
            "dv": "малдивски",
            "dyo": "џола фоњи",
            "dyu": "ђула",
            "dz": "џонга",
            "dzg": "дазага",
            "ebu": "ембу",
            "ee": "еве",
            "efi": "ефички",
            "egy": "староегипатски",
            "eka": "екаџук",
            "el": "грчки",
            "elx": "еламитски",
            "en": "енглески",
            "en-AU": "енглески (Аустралија)",
            "en-CA": "енглески (Канада)",
            "en-GB": "енглески (Уједињено Краљевство)",
            "en-US": "енглески (Сједињене Државе)",
            "enm": "средњеенглески",
            "eo": "есперанто",
            "es": "шпански",
            "es-419": "шпански (Латинска Америка)",
            "es-ES": "шпански (Шпанија)",
            "es-MX": "шпански (Мексико)",
            "et": "естонски",
            "eu": "баскијски",
            "ewo": "евондо",
            "fa": "персијски",
            "fa-AF": "персијски (Авганистан)",
            "fan": "фанг",
            "fat": "фанти",
            "ff": "фулах",
            "fi": "фински",
            "fil": "филипински",
            "fj": "фиџијски",
            "fo": "фарски",
            "fon": "фон",
            "fr": "француски",
            "fr-CA": "француски (Канада)",
            "fr-CH": "француски (Швајцарска)",
            "frc": "кајунски француски",
            "frm": "средњефранцуски",
            "fro": "старофранцуски",
            "frr": "севернофризијски",
            "frs": "источнофризијски",
            "fur": "фриулски",
            "fy": "западни фризијски",
            "ga": "ирски",
            "gaa": "га",
            "gag": "гагауз",
            "gay": "гајо",
            "gba": "гбаја",
            "gd": "шкотски гелски",
            "gez": "геез",
            "gil": "гилбертски",
            "gl": "галицијски",
            "gmh": "средњи високонемачки",
            "gn": "гварани",
            "goh": "старонемачки",
            "gon": "гонди",
            "gor": "горонтало",
            "got": "готски",
            "grb": "гребо",
            "grc": "старогрчки",
            "gsw": "немачки (Швајцарска)",
            "gu": "гуџарати",
            "guz": "гуси",
            "gv": "манкс",
            "gwi": "гвичински",
            "ha": "хауса",
            "hai": "хаида",
            "haw": "хавајски",
            "he": "хебрејски",
            "hi": "хинди",
            "hil": "хилигајнонски",
            "hit": "хетитски",
            "hmn": "хмоншки",
            "ho": "хири моту",
            "hr": "хрватски",
            "hsb": "горњолужичкосрпски",
            "ht": "хаићански креолски",
            "hu": "мађарски",
            "hup": "хупа",
            "hy": "јерменски",
            "hz": "хереро",
            "ia": "интерлингва",
            "iba": "ибански",
            "ibb": "ибибио",
            "id": "индонежански",
            "ie": "интерлингве",
            "ig": "игбо",
            "ii": "сечуански ји",
            "ik": "инупик",
            "ilo": "илоко",
            "inh": "ингушки",
            "io": "идо",
            "is": "исландски",
            "it": "италијански",
            "iu": "инуктитутски",
            "ja": "јапански",
            "jbo": "ложбан",
            "jgo": "нгомба",
            "jmc": "мачаме",
            "jpr": "јудео-персијски",
            "jrb": "јудео-арапски",
            "jv": "јавански",
            "ka": "грузијски",
            "kaa": "кара-калпашки",
            "kab": "кабиле",
            "kac": "качински",
            "kaj": "џу",
            "kam": "камба",
            "kaw": "кави",
            "kbd": "кабардијски",
            "kcg": "тјап",
            "kde": "маконде",
            "kea": "зеленортски",
            "kfo": "коро",
            "kg": "конго",
            "kgp": "kgp",
            "kha": "каси",
            "kho": "котанешки",
            "khq": "којра чиини",
            "ki": "кикују",
            "kj": "квањама",
            "kk": "казашки",
            "kkj": "како",
            "kl": "гренландски",
            "kln": "каленџински",
            "km": "кмерски",
            "kmb": "кимбунду",
            "kn": "канада",
            "ko": "корејски",
            "koi": "коми-пермски",
            "kok": "конкани",
            "kos": "косренски",
            "kpe": "кпеле",
            "kr": "канури",
            "krc": "карачајско-балкарски",
            "kri": "крио",
            "krl": "карелски",
            "kru": "курук",
            "ks": "кашмирски",
            "ksb": "шамбала",
            "ksf": "бафија",
            "ksh": "келнски",
            "ku": "курдски",
            "kum": "кумички",
            "kut": "кутенај",
            "kv": "коми",
            "kw": "корнволски",
            "ky": "киргиски",
            "la": "латински",
            "lad": "ладино",
            "lag": "ланги",
            "lah": "ланда",
            "lam": "ламба",
            "lb": "луксембуршки",
            "lez": "лезгински",
            "lg": "ганда",
            "li": "лимбуршки",
            "lij": "lij",
            "lkt": "лакота",
            "ln": "лингала",
            "lo": "лаошки",
            "lol": "монго",
            "lou": "луизијански креолски",
            "loz": "лози",
            "lrc": "северни лури",
            "lt": "литвански",
            "lu": "луба-катанга",
            "lua": "луба-лулуа",
            "lui": "луисењо",
            "lun": "лунда",
            "luo": "луо",
            "lus": "мизо",
            "luy": "лујиа",
            "lv": "летонски",
            "mad": "мадурски",
            "mag": "магахи",
            "mai": "маитили",
            "mak": "макасарски",
            "man": "мандинго",
            "mas": "масајски",
            "mdf": "мокша",
            "mdr": "мандар",
            "men": "менде",
            "mer": "меру",
            "mfe": "морисјен",
            "mg": "малгашки",
            "mga": "средњеирски",
            "mgh": "макува-мито",
            "mgo": "мета",
            "mh": "маршалски",
            "mi": "маорски",
            "mic": "микмак",
            "min": "минангкабау",
            "mk": "македонски",
            "ml": "малајалам",
            "mn": "монголски",
            "mnc": "манџурски",
            "mni": "манипурски",
            "moh": "мохок",
            "mos": "моси",
            "mr": "марати",
            "ms": "малајски",
            "mt": "малтешки",
            "mua": "мунданг",
            "mul": "Више језика",
            "mus": "кришки",
            "mwl": "мирандски",
            "mwr": "марвари",
            "my": "бурмански",
            "myv": "ерзја",
            "mzn": "мазандерански",
            "na": "науруски",
            "nap": "напуљски",
            "naq": "нама",
            "nb": "норвешки букмол",
            "nd": "северни ндебеле",
            "nds": "нисконемачки",
            "nds-NL": "нисконемачки (Холандија)",
            "ne": "непалски",
            "new": "невари",
            "ng": "ндонга",
            "nia": "ниас",
            "niu": "ниуејски",
            "nl": "холандски",
            "nl-BE": "холандски (Белгија)",
            "nmg": "квасио",
            "nn": "норвешки нинорск",
            "nnh": "нгиембун",
            "no": "норвешки",
            "nog": "ногајски",
            "non": "старонордијски",
            "nqo": "н’ко",
            "nr": "јужни ндебеле",
            "nso": "северни сото",
            "nus": "нуер",
            "nv": "навахо",
            "nwc": "класични неварски",
            "ny": "њанџа",
            "nym": "њамвези",
            "nyn": "њанколе",
            "nyo": "њоро",
            "nzi": "нзима",
            "oc": "окситански",
            "oj": "оџибве",
            "om": "оромо",
            "or": "одија",
            "os": "осетински",
            "osa": "осаге",
            "ota": "османски турски",
            "pa": "пенџапски",
            "pag": "пангасинански",
            "pal": "пахлави",
            "pam": "пампанга",
            "pap": "папијаменто",
            "pau": "палауски",
            "pcm": "нигеријски пиџин",
            "peo": "староперсијски",
            "phn": "феничански",
            "pi": "пали",
            "pl": "пољски",
            "pon": "понпејски",
            "prg": "пруски",
            "pro": "староокситански",
            "ps": "паштунски",
            "pt": "португалски",
            "pt-BR": "португалски (Бразил)",
            "pt-PT": "португалски (Португалија)",
            "qu": "кечуа",
            "quc": "киче",
            "raj": "раџастански",
            "rap": "рапануи",
            "rar": "раротонгански",
            "rhg": "рохингја",
            "rm": "романш",
            "rn": "кирунди",
            "ro": "румунски",
            "ro-MD": "румунски (Молдавија)",
            "rof": "ромбо",
            "rom": "ромски",
            "ru": "руски",
            "rup": "цинцарски",
            "rw": "кињаруанда",
            "rwk": "руа",
            "sa": "санскрит",
            "sad": "сандаве",
            "sah": "саха",
            "sam": "самаријански арамејски",
            "saq": "самбуру",
            "sas": "сасак",
            "sat": "сантали",
            "sba": "нгамбај",
            "sbp": "сангу",
            "sc": "сардински",
            "scn": "сицилијански",
            "sco": "шкотски",
            "sd": "синди",
            "sdh": "јужнокурдски",
            "se": "северни сами",
            "seh": "сена",
            "sel": "селкупски",
            "ses": "којраборо сени",
            "sg": "санго",
            "sga": "староирски",
            "sh": "српскохрватски",
            "shi": "јужни шилха",
            "shn": "шански",
            "si": "синхалешки",
            "sid": "сидамо",
            "sk": "словачки",
            "sl": "словеначки",
            "sm": "самоански",
            "sma": "јужни сами",
            "smj": "луле сами",
            "smn": "инари сами",
            "sms": "сколт сами",
            "sn": "шона",
            "snk": "сонинке",
            "so": "сомалски",
            "sog": "согдијски",
            "sq": "албански",
            "sr": "српски",
            "srn": "сранан тонго",
            "srr": "серерски",
            "ss": "свази",
            "ssy": "сахо",
            "st": "сесото",
            "su": "сундански",
            "suk": "сукума",
            "sus": "сусу",
            "sux": "сумерски",
            "sv": "шведски",
            "sw": "свахили",
            "sw-CD": "свахили (Конго - Киншаса)",
            "swb": "коморски",
            "syc": "сиријачки",
            "syr": "сиријски",
            "ta": "тамилски",
            "te": "телугу",
            "tem": "тимне",
            "teo": "тесо",
            "ter": "терено",
            "tet": "тетум",
            "tg": "таџички",
            "th": "тајски",
            "ti": "тигриња",
            "tig": "тигре",
            "tiv": "тив",
            "tk": "туркменски",
            "tkl": "токелау",
            "tl": "тагалог",
            "tlh": "клингонски",
            "tli": "тлингит",
            "tmh": "тамашек",
            "tn": "цвана",
            "to": "тонгански",
            "tog": "њаса тонга",
            "tpi": "ток писин",
            "tr": "турски",
            "trv": "тароко",
            "ts": "цонга",
            "tsi": "цимшиан",
            "tt": "татарски",
            "tum": "тумбука",
            "tvl": "тувалу",
            "tw": "тви",
            "twq": "тасавак",
            "ty": "тахићански",
            "tyv": "тувински",
            "tzm": "централноатласки тамашек",
            "udm": "удмуртски",
            "ug": "ујгурски",
            "uga": "угаритски",
            "uk": "украјински",
            "umb": "умбунду",
            "und": "непознат језик",
            "ur": "урду",
            "uz": "узбечки",
            "vai": "ваи",
            "ve": "венда",
            "vi": "вијетнамски",
            "vo": "волапик",
            "vot": "водски",
            "vun": "вунџо",
            "wa": "валонски",
            "wae": "валсерски",
            "wal": "волајта",
            "war": "варајски",
            "was": "вашо",
            "wbp": "варлпири",
            "wo": "волоф",
            "xal": "калмички",
            "xh": "исикоса",
            "xog": "сога",
            "yao": "јао",
            "yap": "јапски",
            "yav": "јангбен",
            "ybb": "јемба",
            "yi": "јидиш",
            "yo": "јоруба",
            "yrl": "yrl",
            "yue": "кантонски",
            "za": "џуаншки",
            "zap": "запотечки",
            "zbl": "блисимболи",
            "zen": "зенага",
            "zgh": "стандардни марокански тамашек",
            "zh": "кинески",
            "zh-Hans": "поједностављени кинески",
            "zh-Hant": "традиционални кинески",
            "zu": "исизулу",
            "zun": "зуни",
            "zxx": "без лингвистичког садржаја",
            "zza": "заза"
          },
          "narrow": {
          },
          "short": {
            "az": "азерски",
            "en-GB": "енглески (УК)",
            "en-US": "енглески (САД)"
          }
        }
      },
      "region": {
        "long": {
          "001": "свет",
          "002": "Африка",
          "003": "Северноамерички континент",
          "005": "Јужна Америка",
          "009": "Океанија",
          "011": "Западна Африка",
          "013": "Централна Америка",
          "014": "Источна Африка",
          "015": "Северна Африка",
          "017": "Централна Африка",
          "018": "Јужна Африка",
          "019": "Северна и Јужна Америка",
          "021": "Северна Америка",
          "029": "Кариби",
          "030": "Источна Азија",
          "034": "Јужна Азија",
          "035": "Југоисточна Азија",
          "039": "Јужна Европа",
          "053": "Аустралија и Нови Зеланд",
          "054": "Меланезија",
          "057": "Микронезијски регион",
          "061": "Полинезија",
          "142": "Азија",
          "143": "Централна Азија",
          "145": "Западна Азија",
          "150": "Европа",
          "151": "Источна Европа",
          "154": "Северна Европа",
          "155": "Западна Европа",
          "202": "Подсахарска Африка",
          "419": "Латинска Америка",
          "AC": "Острво Асенсион",
          "AD": "Андора",
          "AE": "Уједињени Арапски Емирати",
          "AF": "Авганистан",
          "AG": "Антигва и Барбуда",
          "AI": "Ангвила",
          "AL": "Албанија",
          "AM": "Јерменија",
          "AO": "Ангола",
          "AQ": "Антарктик",
          "AR": "Аргентина",
          "AS": "Америчка Самоа",
          "AT": "Аустрија",
          "AU": "Аустралија",
          "AW": "Аруба",
          "AX": "Оландска Острва",
          "AZ": "Азербејџан",
          "BA": "Босна и Херцеговина",
          "BB": "Барбадос",
          "BD": "Бангладеш",
          "BE": "Белгија",
          "BF": "Буркина Фасо",
          "BG": "Бугарска",
          "BH": "Бахреин",
          "BI": "Бурунди",
          "BJ": "Бенин",
          "BL": "Свети Бартоломеј",
          "BM": "Бермуда",
          "BN": "Брунеј",
          "BO": "Боливија",
          "BQ": "Карипска Холандија",
          "BR": "Бразил",
          "BS": "Бахами",
          "BT": "Бутан",
          "BV": "Острво Буве",
          "BW": "Боцвана",
          "BY": "Бјелорусија",
          "BZ": "Белизе",
          "CA": "Канада",
          "CC": "Кокосова (Килингова) Острва",
          "CD": "Конго - Киншаса",
          "CF": "Централноафричка Република",
          "CG": "Конго",
          "CH": "Швајцарска",
          "CI": "Обала Слоноваче (Кот д’Ивоар)",
          "CK": "Кукова Острва",
          "CL": "Чиле",
          "CM": "Камерун",
          "CN": "Кина",
          "CO": "Колумбија",
          "CP": "Острво Клипертон",
          "CR": "Костарика",
          "CU": "Куба",
          "CV": "Зеленортска Острва",
          "CW": "Курасао",
          "CX": "Божићно Острво",
          "CY": "Кипар",
          "CZ": "Чешка Република",
          "DE": "Њемачка",
          "DG": "Дијего Гарсија",
          "DJ": "Џибути",
          "DK": "Данска",
          "DM": "Доминика",
          "DO": "Доминиканска Република",
          "DZ": "Алжир",
          "EA": "Сеута и Мелиља",
          "EC": "Еквадор",
          "EE": "Естонија",
          "EG": "Египат",
          "EH": "Западна Сахара",
          "ER": "Еритреја",
          "ES": "Шпанија",
          "ET": "Етиопија",
          "EU": "Европска унија",
          "EZ": "Еврозона",
          "FI": "Финска",
          "FJ": "Фиџи",
          "FK": "Фокландска Острва",
          "FM": "Микронезија",
          "FO": "Фарска Острва",
          "FR": "Француска",
          "GA": "Габон",
          "GB": "Уједињено Краљевство",
          "GD": "Гренада",
          "GE": "Грузија",
          "GF": "Француска Гвајана",
          "GG": "Гернзи",
          "GH": "Гана",
          "GI": "Гибралтар",
          "GL": "Гренланд",
          "GM": "Гамбија",
          "GN": "Гвинеја",
          "GP": "Гваделуп",
          "GQ": "Екваторијална Гвинеја",
          "GR": "Грчка",
          "GS": "Јужна Џорџија и Јужна Сендвичка Острва",
          "GT": "Гватемала",
          "GU": "Гуам",
          "GW": "Гвинеја-Бисао",
          "GY": "Гвајана",
          "HK": "САР Хонгконг (Кина)",
          "HM": "Острво Херд и Мекдоналдова острва",
          "HN": "Хондурас",
          "HR": "Хрватска",
          "HT": "Хаити",
          "HU": "Мађарска",
          "IC": "Канарска Острва",
          "ID": "Индонезија",
          "IE": "Ирска",
          "IL": "Израел",
          "IM": "Острво Ман",
          "IN": "Индија",
          "IO": "Британска територија Индијског океана",
          "IQ": "Ирак",
          "IR": "Иран",
          "IS": "Исланд",
          "IT": "Италија",
          "JE": "Џерзи",
          "JM": "Јамајка",
          "JO": "Јордан",
          "JP": "Јапан",
          "KE": "Кенија",
          "KG": "Киргистан",
          "KH": "Камбоџа",
          "KI": "Кирибати",
          "KM": "Коморска Острва",
          "KN": "Свети Китс и Невис",
          "KP": "Северна Кореја",
          "KR": "Јужна Кореја",
          "KW": "Кувајт",
          "KY": "Кајманска Острва",
          "KZ": "Казахстан",
          "LA": "Лаос",
          "LB": "Либан",
          "LC": "Света Луција",
          "LI": "Лихтенштајн",
          "LK": "Шри Ланка",
          "LR": "Либерија",
          "LS": "Лесото",
          "LT": "Литванија",
          "LU": "Луксембург",
          "LV": "Летонија",
          "LY": "Либија",
          "MA": "Мароко",
          "MC": "Монако",
          "MD": "Молдавија",
          "ME": "Црна Гора",
          "MF": "Свети Мартин (Француска)",
          "MG": "Мадагаскар",
          "MH": "Маршалска Острва",
          "MK": "Северна Македонија",
          "ML": "Мали",
          "MM": "Мијанмар (Бурма)",
          "MN": "Монголија",
          "MO": "САР Макао (Кина)",
          "MP": "Северна Маријанска Острва",
          "MQ": "Мартиник",
          "MR": "Мауританија",
          "MS": "Монсерат",
          "MT": "Малта",
          "MU": "Маурицијус",
          "MV": "Малдиви",
          "MW": "Малави",
          "MX": "Мексико",
          "MY": "Малезија",
          "MZ": "Мозамбик",
          "NA": "Намибија",
          "NC": "Нова Каледонија",
          "NE": "Нигер",
          "NF": "Острво Норфок",
          "NG": "Нигерија",
          "NI": "Никарагва",
          "NL": "Холандија",
          "NO": "Норвешка",
          "NP": "Непал",
          "NR": "Науру",
          "NU": "Ниуе",
          "NZ": "Нови Зеланд",
          "OM": "Оман",
          "PA": "Панама",
          "PE": "Перу",
          "PF": "Француска Полинезија",
          "PG": "Папуа Нова Гвинеја",
          "PH": "Филипини",
          "PK": "Пакистан",
          "PL": "Пољска",
          "PM": "Свети Пјер и Микелон",
          "PN": "Питкерн",
          "PR": "Порторико",
          "PS": "Палестинске територије",
          "PT": "Португалија",
          "PW": "Палау",
          "PY": "Парагвај",
          "QA": "Катар",
          "QO": "Океанија (удаљена острва)",
          "RE": "Реунион",
          "RO": "Румунија",
          "RS": "Србија",
          "RU": "Русија",
          "RW": "Руанда",
          "SA": "Саудијска Арабија",
          "SB": "Соломонска Острва",
          "SC": "Сејшели",
          "SD": "Судан",
          "SE": "Шведска",
          "SG": "Сингапур",
          "SH": "Света Јелена",
          "SI": "Словенија",
          "SJ": "Свалбард и Јан Мајен",
          "SK": "Словачка",
          "SL": "Сијера Леоне",
          "SM": "Сан Марино",
          "SN": "Сенегал",
          "SO": "Сомалија",
          "SR": "Суринам",
          "SS": "Јужни Судан",
          "ST": "Сао Томе и Принципе",
          "SV": "Салвадор",
          "SX": "Свети Мартин (Холандија)",
          "SY": "Сирија",
          "SZ": "Свазиленд",
          "TA": "Тристан да Куња",
          "TC": "Острва Туркс и Каикос",
          "TD": "Чад",
          "TF": "Француске Јужне Територије",
          "TG": "Того",
          "TH": "Тајланд",
          "TJ": "Таџикистан",
          "TK": "Токелау",
          "TL": "Тимор-Лесте (Источни Тимор)",
          "TM": "Туркменистан",
          "TN": "Тунис",
          "TO": "Тонга",
          "TR": "Турска",
          "TT": "Тринидад и Тобаго",
          "TV": "Тувалу",
          "TW": "Тајван",
          "TZ": "Танзанија",
          "UA": "Украјина",
          "UG": "Уганда",
          "UM": "Мања удаљена острва САД",
          "UN": "Уједињене нације",
          "US": "Сједињене Државе",
          "UY": "Уругвај",
          "UZ": "Узбекистан",
          "VA": "Ватикан",
          "VC": "Свети Винсент и Гренадини",
          "VE": "Венецуела",
          "VG": "Британска Дјевичанска Острва",
          "VI": "Америчка Дјевичанска Острва",
          "VN": "Вијетнам",
          "VU": "Вануату",
          "WF": "Валис и Футуна",
          "WS": "Самоа",
          "XA": "Псеудоакценти",
          "XB": "Псеудобиди",
          "XK": "Косово",
          "YE": "Јемен",
          "YT": "Мајот",
          "ZA": "Јужноафричка Република",
          "ZM": "Замбија",
          "ZW": "Зимбабве",
          "ZZ": "Непознат регион"
        },
        "narrow": {
        },
        "short": {
          "GB": "УК",
          "HK": "Хонгконг",
          "MO": "Макао",
          "PS": "Палестина",
          "UN": "УН",
          "US": "САД"
        }
      },
      "script": {
        "long": {
          "Adlm": "Adlm",
          "Aghb": "Aghb",
          "Ahom": "Ahom",
          "Arab": "арапско писмо",
          "Aran": "Aran",
          "Armi": "империјско арамејско писмо",
          "Armn": "јерменско писмо",
          "Avst": "авестанско писмо",
          "Bali": "балијско писмо",
          "Bamu": "Bamu",
          "Bass": "Bass",
          "Batk": "батак писмо",
          "Beng": "бенгалско писмо",
          "Bhks": "Bhks",
          "Blis": "блисимболично писмо",
          "Bopo": "бопомофо писмо",
          "Brah": "браманско писмо",
          "Brai": "брајево писмо",
          "Bugi": "бугинско писмо",
          "Buhd": "бухидско писмо",
          "Cakm": "чакманско писмо",
          "Cans": "уједињени канадски абориџински силабици",
          "Cari": "каријско писмо",
          "Cham": "чамско писмо",
          "Cher": "Чероки",
          "Chrs": "Chrs",
          "Cirt": "цирт писмо",
          "Copt": "коптичко писмо",
          "Cpmn": "Cpmn",
          "Cprt": "кипарско писмо",
          "Cyrl": "ћирилица",
          "Cyrs": "Старословенска црквена ћирилица",
          "Deva": "деванагари",
          "Diak": "Diak",
          "Dogr": "Dogr",
          "Dsrt": "Дезерет",
          "Dupl": "Dupl",
          "Egyd": "египатско народно писмо",
          "Egyh": "египатско хијератско писмо",
          "Egyp": "египатски хијероглифи",
          "Elba": "Elba",
          "Elym": "Elym",
          "Ethi": "етиопско писмо",
          "Geok": "грузијско кхутсури писмо",
          "Geor": "грузијско писмо",
          "Glag": "глагољица",
          "Gong": "Gong",
          "Gonm": "Gonm",
          "Goth": "Готика",
          "Gran": "Gran",
          "Grek": "грчко писмо",
          "Gujr": "гуџаратско писмо",
          "Guru": "гурмуки писмо",
          "Hanb": "ханб",
          "Hang": "хангул",
          "Hani": "хан",
          "Hano": "хануно",
          "Hans": "поједностављено кинеско писмо",
          "Hant": "традиционално кинеско писмо",
          "Hatr": "Hatr",
          "Hebr": "хебрејско писмо",
          "Hira": "хирагана",
          "Hluw": "Hluw",
          "Hmng": "пахав хмонг писмо",
          "Hmnp": "Hmnp",
          "Hrkt": "јапанска слоговна писма",
          "Hung": "старомађарско писмо",
          "Inds": "индушко писмо",
          "Ital": "стари италик",
          "Jamo": "џамо",
          "Java": "јаванско писмо",
          "Jpan": "јапанско писмо",
          "Kali": "кајах-ли писмо",
          "Kana": "катакана",
          "Khar": "карошти писмо",
          "Khmr": "кмерско писмо",
          "Khoj": "Khoj",
          "Kits": "Kits",
          "Knda": "канада писмо",
          "Kore": "корејско писмо",
          "Kthi": "каити",
          "Lana": "ланна писмо",
          "Laoo": "лаошко писмо",
          "Latf": "латиница (фрактур варијанта)",
          "Latg": "галска латиница",
          "Latn": "латиница",
          "Lepc": "лепча писмо",
          "Limb": "лимбу писмо",
          "Lina": "линеарно А писмо",
          "Linb": "линеарно Б писмо",
          "Lisu": "Lisu",
          "Lyci": "лисијско писмо",
          "Lydi": "лидијско писмо",
          "Mahj": "Mahj",
          "Maka": "Maka",
          "Mand": "мандеанско писмо",
          "Mani": "манихејско писмо",
          "Marc": "Marc",
          "Maya": "мајански хијероглифи",
          "Medf": "Medf",
          "Mend": "Mend",
          "Merc": "Merc",
          "Mero": "мероитик писмо",
          "Mlym": "малајаламско писмо",
          "Modi": "Modi",
          "Mong": "монголско писмо",
          "Moon": "месечево писмо",
          "Mroo": "Mroo",
          "Mtei": "меитеи мајек писмо",
          "Mult": "Mult",
          "Mymr": "мијанмарско писмо",
          "Nand": "Nand",
          "Narb": "Narb",
          "Nbat": "Nbat",
          "Newa": "Newa",
          "Nkoo": "н’ко писмо",
          "Nshu": "Nshu",
          "Ogam": "огамско писмо",
          "Olck": "ол чики писмо",
          "Orkh": "орконско писмо",
          "Orya": "оријанско писмо",
          "Osge": "Osge",
          "Osma": "осмањанско писмо",
          "Ougr": "Ougr",
          "Palm": "Palm",
          "Pauc": "Pauc",
          "Perm": "старо пермикско писмо",
          "Phag": "пагс-па писмо",
          "Phli": "писани пахлави",
          "Phlp": "псалтер пахлави",
          "Phlv": "пахлави писмо",
          "Phnx": "Феничанско писмо",
          "Plrd": "поралд фонетско писмо",
          "Prti": "писани партиан",
          "Qaag": "Qaag",
          "Rjng": "рејанг писмо",
          "Rohg": "Rohg",
          "Roro": "ронгоронго писмо",
          "Runr": "рунско писмо",
          "Samr": "самаританско писмо",
          "Sara": "сарати писмо",
          "Sarb": "Sarb",
          "Saur": "саураштра писмо",
          "Sgnw": "знаковно писмо",
          "Shaw": "шавијанско писмо",
          "Shrd": "Shrd",
          "Sidd": "Sidd",
          "Sind": "Sind",
          "Sinh": "синхалско писмо",
          "Sogd": "Sogd",
          "Sogo": "Sogo",
          "Sora": "Sora",
          "Soyo": "Soyo",
          "Sund": "сунданско писмо",
          "Sylo": "силоти нагри писмо",
          "Syrc": "сиријско писмо",
          "Syre": "сиријско естрангело писмо",
          "Syrj": "западносиријско писмо",
          "Syrn": "писмо источне Сирије",
          "Tagb": "тагбанва писмо",
          "Takr": "Takr",
          "Tale": "таи ле писмо",
          "Talu": "нови таи луе",
          "Taml": "тамилско писмо",
          "Tang": "Tang",
          "Tavt": "таи виет писмо",
          "Telu": "телугу писмо",
          "Teng": "тенгвар писмо",
          "Tfng": "тифинаг писмо",
          "Tglg": "Тагалог",
          "Thaa": "тана писмо",
          "Thai": "тајландско писмо",
          "Tibt": "тибетанско писмо",
          "Tirh": "Tirh",
          "Tnsa": "Tnsa",
          "Toto": "Toto",
          "Ugar": "угаритско писмо",
          "Vaii": "ваи писмо",
          "Visp": "видљиви говор",
          "Vith": "Vith",
          "Wara": "Wara",
          "Wcho": "Wcho",
          "Xpeo": "староперсијско писмо",
          "Xsux": "сумерско-акадско кунеиформ писмо",
          "Yezi": "Yezi",
          "Yiii": "ји писмо",
          "Zanb": "Zanb",
          "Zinh": "наследно писмо",
          "Zmth": "математичка нотација",
          "Zsye": "емоџи",
          "Zsym": "симболи",
          "Zxxx": "неписани језик",
          "Zyyy": "заједничко писмо",
          "Zzzz": "непознато писмо"
        },
        "narrow": {
        },
        "short": {
        }
      }
    }
  },
  "locale": "sr-Cyrl-ME"
})
}